import { useState, useEffect } from 'react';

import useTextKeyLimit from '../../../commons/hooks/useTextKeyLimit';
import Validations, { InputPatterns } from '../../../commons/validations';


const defaultCountry = {
    code: '61',
    index: 2,
    country: 'au',
};

function useCountryCodeUIState (props) {
    const {
        value,
    } = props;

    const [countryCode, setCountryCode] = useState(value.countryCode || defaultCountry.code);
    const [country, setCountry] = useState(defaultCountry.country);
    
    const [openList, setOpenList] = useState(false);
    const [listAnchor, setListAnchor] = useState(null);
    const [codeIndex, setCodeIndex] = useState(value.codeIndex || defaultCountry.index);
    const [phoneNumber, setPhoneNumber] = useState(value.phoneNumber || '');

    const {
        onKeyDown: onPhoneKeyDown,
    } = useTextKeyLimit({
        includedPattern: InputPatterns.phone,
        charLimit: Validations.phone.maxLength,
        pasteEnabled: false,
    });

    useEffect(() => {
        setCountryCode(value.countryCode);
        setPhoneNumber(value.phoneNumber);
        setCountry(value.country);
        setCodeIndex(value.codeIndex);
    }, [value]);

    function openCountryCodeList (p) {
        setListAnchor(p.anchor);
        setOpenList(true);
    }
    
    function closeCountryCodeList () {
        setOpenList(false);
    }

    function selectCountryCode (p) {
        console.log('selecteCountryCode() ', p);
        setCountry(p.data.iso2);
        setCodeIndex(p.index);
        setCountryCode(p.data.code);
    }

    return {
        countryCode,
        openList,
        listAnchor,
        openCountryCodeList,
        closeCountryCodeList,
        selectCountryCode,
        codeIndex,
        country,
        onPhoneKeyDown,

        phoneNumber,
        setPhoneNumber,
    };
}

export default useCountryCodeUIState;
